import React from "react";
import PropTypes from "prop-types";
import { Drawer, Icon } from "antd";
import DocumentService from "services/documents-service";
import moment from "moment";
class DocumentsDrawer extends React.Component {

    state={
        showDocViewer: false,
        files: []
    };

    closeDocViewer = () => {
        this.setState({
            files: [],
            showDocViewer: false
        });
    }

    openDocViewer = () => {
        this.props.urls.map(_ => {
            DocumentService.getDocumentUrl(typeof _ === "object" ? _.file : _, false).then(({headers}) => {
                this.setState({
                    files: [
                        ...this.state.files,
                        {
                            url: typeof _ === "object" ? _.file : _,
                            fileType: headers["content-type"],
                            create_date: _.create_date,
                            created_by_user: _.created_by_user
                        }
                    ],
                    showDocViewer: true
                });
            });
        });
    }

    render() {
        return(
            <React.Fragment>
                <Drawer
                    title="Documents"
                    placement="right"
                    closable={true}
                    width="600px"
                    visible={this.state.showDocViewer}
                    onClose={this.closeDocViewer}
                >
                    <div className={"d-flex flex-column"}>
                        {this.state.files
                            ? this.state.files.sort((a,b)=>new Date(b.create_date)-new Date(a.create_date)).map((_, k) =>(
                                <div
                                    className={"p-5"}
                                    key={`${_.url}-${k}`}
                                >
                                    {_.fileType && _.fileType.includes("pdf") ? (
                                        <iframe
                                            width={"100%"} height={500}
                                            src={`${process.env.FILE_DOWNLOAD_URL}/${_.url}`}
                                        />
                                    ) : null}
                                    {_.fileType && !_.fileType.includes("pdf") ? (
                                        <img
                                            src={`${process.env.FILE_DOWNLOAD_URL}/${_.url}`}
                                            width={"100%"}
                                        />
                                    ): null}
                                    <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between"}}>
                                        {_.create_date && <p> <span style={{fontWeight:700}}>Created At:</span> {moment(_.create_date).format("DD-MM-YYYY hh:mm:ss a")}</p>}
                                        {_.created_by_user && <p> <span style={{fontWeight:700}}>Created By:</span> {_.created_by_user}</p>}
                                    </div>
                                </div>
                            ))
                            : null}
                    </div>
                </Drawer>
                <Icon type="file-image" theme="filled" onClick={this.openDocViewer} style={{ color: "#00a0ff", paddingLeft: "20px" }} />
            </React.Fragment>
        );
    }
}

DocumentsDrawer.defaultProps = {
    urls: []
};

DocumentsDrawer.propTypes = {
    urls: PropTypes.array,
    openDocViewer: PropTypes.bool,
    closeDocViewer: PropTypes.func,
    createdDate: PropTypes.string,
    createdByUser: PropTypes.string,
};

export default (DocumentsDrawer);